import React, { Component } from "react";
import './App.css';
import { Link } from 'react-router-dom';
import { Button} from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CardDeck from 'react-bootstrap/CardDeck';
import LoadingSpinner from "./components/LoadingSpinner";
import { Table } from 'react-bootstrap';
import videoCoffee from './assets/videocoffee.mp4';
import posterCoffee from './assets/postercoffee.png';
import Footer from './Footer_se.js';
import i18n from './i18n';


class Pricing_se extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false, 
      videoCoffeSrc: ''
    };
  }

  // Let's our app know we're ready to render the data
  componentDidMount() {
    i18n.changeLanguage('se');
    this.setState({
      videoCoffeeSrc: videoCoffee
  })
  };


 
  orderUser(){
    this.orderSubscription("User");
  }




  render () {
    const { isLoading } = this.state;

    if (isLoading) {
      return <div className="Sign"><LoadingSpinner/></div>;
    }


  return (
    <React.Fragment>
       <div className="showcase">
       <video src={this.state.videoCoffeeSrc} poster={posterCoffee} muted loop playsInline autoPlay></video>
      {/* <div className="overlay"></div> */}
      <div className="text">
            <br/>
            <h2 >Priser</h2> 
            <br/>
            <CardDeck>
            <Card style={{ width: '18rem' }}>
            <Card.Body>
                <Card.Title><b>En användare</b></Card.Title>
                <Card.Text style={{color: "grey", fontWeight: "300"}}>
                För en chef <br />
                600 kr/månad exkl. moms<br />
                Faktureras årligen
                </Card.Text>
            </Card.Body>
            </Card>
            <Card style={{ width: '18rem' }}>
            <Card.Body>
            <Card.Title><b>Grupper</b></Card.Title>
                <Card.Text  style={{color: "grey", fontWeight: "300"}}>
                Upp till 5 chefer <br />
                2000 kr/månad exkl. moms<br />
                Faktureras årligen
                </Card.Text>
            </Card.Body>
            </Card>
            <Card style={{ width: '18rem' }}>
            <Card.Body>
            <Card.Title><b>Mindre företag</b></Card.Title>
                <Card.Text  style={{color: "grey", fontWeight: "300"}}>
                Upp to 20 chefer <br />
                6.000 kr/månad exkl. moms<br />
                Faktureras årligen
                </Card.Text>
            </Card.Body>
            </Card>
            <Card style={{ width: '18rem' }}>
            <Card.Body>
            <Card.Title><b>Större företag</b></Card.Title>
                <Card.Text  style={{color: "grey", fontWeight: "300"}}>
                Upp till 100 chefer<br />
                24.000 kr/månad exkl. moms<br />
                Faktureras årligen
                </Card.Text>
            </Card.Body>
            </Card>
            
            </CardDeck>
            
            

                
        <LoadingSpinner/>
        <Link className="float-right" to={`/signup_se`} style= {{backgroundColor: "transparent"}}><Button  variant="primary" className="btn-lg">Testa GRATIS</Button></Link>
        <Table borderless>
            <tr>
            <td></td>
        </tr>
        </Table>
        <br /><br />
        </div>
      </div>
      <Footer/>

    </React.Fragment>
  );
};
};

export default Pricing_se;